import { QUEST_SLUGS } from 'utils/constants/products';

/**
 * Validate if a product belongs to Quest based on its slug
 * @param slug
 * @returns
 */
export const isQuestProduct = (slug: string): boolean =>
  QUEST_SLUGS.includes(slug);

export const QUEST_TAG = 'In-person test';
